import { useQuery } from '@tanstack/react-query';

import useAgent from '../api/useAgent';

const useWorkOrderStatuses = () => {
	const { get } = useAgent();

	return useQuery({
		queryKey: ['maintenance/work-order/statuses'],
		queryFn: async ({ queryKey }) => {
			const { data } = await get(queryKey.join(''));

			return data;
		},
		staleTime: Infinity,
		refetchOnWindowFocus: false,
		retry: false
	});
};

export default useWorkOrderStatuses;
